import React, { useEffect, useState } from "react";
import { Navbar } from "../../Components/Navbar";
import "./linkRegister.css";
import {
  addLeaseTagAssets,
  deleteLeaseTagAssets,
  dropLeaseTagAssets,
  getLeaseTagAssets,
  removeLeaseTagAssetItem,
} from "../../services/api/apiHandler";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import swal from "sweetalert";
import CommonToolTip from "../../Components/Common/CommonToolTip";
import ErrorIcon from "@mui/icons-material/Error";
import Loading from "../../Components/Common/Loader/Loading";
import LoaderTwo from "../../Components/Common/Loader/LoaderTwo";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DotIndicatorSVGComponent from "../../Components/Common/SVGComponents/DotIndicatorSVGComponent";

import Sidebar from "../../myfin_v2/elements/Sidebar";
// import FSTopBar from "../../myfin_v2/components/fs/FSTopBar";
import commoncss from "../../myfin_v2/css/common.module.css";
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css";
import workSpaceCss from "../../myfin_v2/css/workSpaceOverView.module.css";
import standaloneCss from "../../myfin_v2/css/standalone.module.css";
import FSCss from "../../myfin_v2/css/overview.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import { Button } from "../../myfin_v2/elements/Button";
import NoteSoftDelete from "../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";
import { ReactComponent as Plus } from "../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as LeftArrowIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as GreenDot } from "../../myfin_v2/assets/icons/greenDotSmall.svg";

const FSTopBar = ({
  // setLoanUploadModal,
  ShowInDecimals,
  setShowInDecimals,
  //  history,
  softDeletedData,
  deleteItemsModel,
  setDeleteItemsModal,
  handleDelete,
  setHandleDelete,
}) => {
  const history = useHistory();
  // const dispatch = useDispatch();
  return (
    <div className={FSCss.w100}>
      <div className={FSCss.uploadLoansMainContainer}></div>

      <div className={FSCss.listPageheader}>
        <div className={FSCss.headerLeftContainer}>
          {/* <div className={FSCss.heading}>Loan Listing</div> */}
          {/* <div className={FSCss.heading}  > */}

          <div className={FSCss.iconContainer}>
            {/* <SearchIcon/> */}
            <LeftArrowIcon
              className="clickable"
              //   onClick={redirectToBookClosureHome}
              //  onClick={() => {dispatch({ type: "NOTE_KEY", payload: 2 }); history.push(`/financialstatement`) }}
              onClick={() => history.push(`/link-register`)}
            />
          </div>
          <div
            className={FSCss.topBarHeading}
            style={{ "align-content": "center" }}
          >
            Workspace
          </div>
          <div className={FSCss.iconDotContainer}>
            {/* <SearchIcon/> */}
            <GreenDot />
          </div>

          <div
            className={FSCss.topBarHeading}
            style={{ "align-content": "center" }}
          >
            Standalone Financial Statements
          </div>
          <div className={FSCss.iconDotContainer}>
            {/* <SearchIcon/> */}
            <GreenDot />
          </div>
          <div className={FSCss.topBarSubHeading}>Financial Statement name</div>

          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

const LeaseTagAssets = () => {
  const history = useHistory();
  const { leaseIndex } = useParams();
  const project_id = localStorage.getItem("project_id");
  const tb_id = localStorage.getItem("tb_id");

  const [assetsData, setAssetsData] = useState({
    leaseAssets: [],
    finanCialAssets: [],
  });
  const [tagAssets, setTagAssets] = useState([]);
  const [draggedData, setDraggedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dropLoading, setDropLoading] = useState(false);

  useEffect(() => {
    if (leaseIndex) {
      setLoading(true);
      getLeaseTagAssets(project_id, tb_id, leaseIndex)
        .then((res) => {
          setLoading(false);
          setAssetsData((prev) => {
            return {
              ...prev,
              finanCialAssets: res?.data?.subGrpArray,
              leaseAssets: res?.data?.leaseAssets ?? [],
            };
          });
          setTagAssets(res?.data?.tagAssets);
        })
        .catch((err) => {
          setLoading(false);
          swal(
            "Error",
            err?.response?.data?.error ||
              "Error: Lease Register Tag Assets API Failed!",
            "error"
          );
        });
    }
  }, []);

  const AddNewItem = () => {
    setDropLoading(true);
    addLeaseTagAssets(project_id, tb_id, leaseIndex)
      .then((res) => {
        setDropLoading(false);
        setTagAssets(res.data.tagAssets);
      })
      .catch((err) => {
        setDropLoading(false);
        swal(
          "Error",
          err.response.data.error ||
            "Error: Lease Register Tag Assets API Failed!",
          "error"
        );
      });
  };

  const handleDragStart = (e, ele) => {
    setDraggedData(ele);
  };

  const handleDrop = (e, key, index) => {
    e.preventDefault();
    if (!draggedData) return;
    const group = key === "financialAssets" ? "sub_grp" : "assetClass";
    const filteredData = tagAssets.reduce((acc, obj) => {
      const financialAsset = obj[key].find(
        (asset) => asset[group] === draggedData[group]
      );
      if (financialAsset) {
        acc.push(financialAsset);
      }
      return acc;
    }, []);

    if (filteredData.length > 0) {
      return swal("Warning", "Tag Asset Already Mapped!", "warning");
    }

    const data = {
      draggedData,
      key,
      index,
      leaseIndex,
    };
    setDropLoading(true);
    dropLeaseTagAssets(project_id, tb_id, data)
      .then((res) => {
        setDropLoading(false);
        setTagAssets(res.data.tagAssets);
        setDraggedData(null);
      })
      .catch((err) => {
        setDropLoading(false);
        swal(
          "Error",
          err.response.data.error ||
            "Error: Lease Register Tag Assets API Failed!",
          "error"
        );
      });
  };

  const RemoveItem = (element, key, index) => {
    const data = {
      element,
      key,
      index,
      leaseIndex,
    };

    setDropLoading(true);
    removeLeaseTagAssetItem(project_id, tb_id, data)
      .then((res) => {
        setDropLoading(false);
        setTagAssets(res.data.tagAssets);
      })
      .catch((err) => {
        setDropLoading(false);
        swal(
          "Error",
          err.response.data.error ||
            "Error: Lease Register Tag Assets API Failed!",
          "error"
        );
      });
  };

  const checkCondition = (index, element) => {
    const totalFinancialAssets = (
      tagAssets[index]?.financialAssets ?? []
    ).reduce(
      (acc, item) => {
        acc.totalPyAmt += item.py_amt;
        acc.totalCyAmt += item.cy_amt;
        return acc;
      },
      { totalPyAmt: 0, totalCyAmt: 0 }
    );

    return (
      (totalFinancialAssets.totalPyAmt !== element.py ||
        totalFinancialAssets.totalCyAmt !== element.cy) && (
        <div className="d-flex align-items-center justify-content-center">
          <CommonToolTip
            variant="primary"
            title={"The values are not matching."}
            placement="top"
          >
            <ErrorIcon
              style={{
                color: "darkorange",
                cursor: "pointer",
              }}
              className="financialInstrument-hoverIcon"
            />
          </CommonToolTip>
        </div>
      )
    );
  };

  const DeleteItem = (index) => {
    setDropLoading(true);
    deleteLeaseTagAssets(project_id, tb_id, index)
      .then((res) => {
        setDropLoading(false);
        setTagAssets(res.data.tagAssets);
      })
      .catch((err) => {
        setDropLoading(false);
        swal(
          "Error",
          err.response.data.error ||
            "Error: Lease Register Tag Assets API Failed!",
          "error"
        );
      });
  };

  return (
    <React.Fragment>
      <div className={`${workSpaceCss.df}`}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <div className={bookclosurecss.bookClosureContent}>
            <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
              <FSTopBar />
            </div>
            <div style={{ height: "88vh", overflow: "auto" }}>
              {loading ? (
                <Loading />
              ) : (
                <div>
                  <div className="d-flex bg-transparent mb-2">
                    <div className="col-sm-3">
                      <div className="radius-10px mt-3 border">
                        <p className="m-0 p-3 font-weight-bold font-size-14 font-sans  border-radius-t-lf-10">
                          Category of assets - Lease register
                        </p>
                        <div
                          className={`p-2 tag-assets-options bg-white ${commoncss.dFlexClm}`}
                          style={{
                            gap: "10px",
                            height: "76vh",
                            overflow: "auto",
                          }}
                        >
                          {assetsData.leaseAssets.length > 0 &&
                            assetsData.leaseAssets.map((asset, index) => (
                              <div
                                key={index}
                                draggable
                                onDragStart={(e) => handleDragStart(e, asset)}
                                className={`cursor-pointer text-secondary  d-flex align-items-center  ${standaloneCss.taggedAssets}`}
                              >
                                <div>
                                  <DotIndicatorSVGComponent
                                    color={"#DFE2E7"}
                                    height={21}
                                    width={13}
                                  />
                                </div>
                                <p className={`m-0 ml-2 ${commoncss.label3}`}>
                                  {asset?.assetClass}
                                </p>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div
                        className="w-100 d-flex justify-content-center align-items-center"
                        style={{ height: "1.5rem" }}
                      >
                        {dropLoading && <LoaderTwo />}
                      </div>

                      <p className="m-0 px-3 py-2 font-size-16 font-inter">
                        Enter class of assets
                      </p>
                      <div
                        className="d-flex flex-column justify-content-between border radius-10px bg-white"
                        style={{ height: "76vh", overflow: "auto" }}
                      >
                        <div>
                          {tagAssets.length > 0 &&
                            tagAssets.map((tag, tx) => (
                              <div key={tx} className="p-2 mt-1">
                                <div className="d-flex justify-content-center align-items-center w-100">
                                  <div className="tag-assets-option-hr"></div>
                                  <p
                                    className="text-secondary font-size-12 custom-font-500 font-inter m-0 text-center"
                                    style={{ width: "20%" }}
                                  >
                                    Class of Assets {tx + 1}
                                  </p>
                                  <div className="tag-assets-option-hr"></div>
                                </div>

                                <div
                                  className="d-flex justify-content-between pt-2"
                                  style={{ gap: "10px" }}
                                >
                                  <div
                                    className={`w-50 ${standaloneCss.dragDropAreaTagAssets}`}
                                    style={{
                                      minHeight: "2rem",
                                      padding: "10px 30px",
                                    }}
                                    onDragEnter={(e) => e.preventDefault()}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) =>
                                      handleDrop(e, "leaseAssets", tx)
                                    }
                                    onDragLeave={(e) => e.preventDefault()}
                                  >
                                    <label
                                      htmlFor="file-upload"
                                      className={`${standaloneCss.dragDropLabelTagAssets} mb-0`}
                                    >
                                      Drag and drop your Register here or
                                    </label>
                                    {tag.leaseAssets.length > 0 &&
                                      tag.leaseAssets.map((asset, ax) => (
                                        <div
                                          key={ax}
                                          className={`cursor-pointer text-secondary  d-flex align-items-center justify-content-between  ${standaloneCss.taggedAssets}`}
                                        >
                                          <div className="d-flex align-items-center">
                                            <div>
                                              <DotIndicatorSVGComponent
                                                color={"#DFE2E7"}
                                                height={21}
                                                width={13}
                                              />
                                            </div>
                                            <p
                                              className={`m-0 ml-2 ${commoncss.label3}`}
                                            >
                                              {asset?.assetClass}
                                            </p>
                                          </div>
                                          <div
                                            onClick={() =>
                                              RemoveItem(
                                                asset,
                                                "leaseAssets",
                                                tx
                                              )
                                            }
                                          >
                                            <RemoveIcon />
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                  <div
                                    className={`w-50 ${
                                      tag.financialAssets.length < 1
                                        ? `${standaloneCss.dragDropAreaTagAssets}`
                                        : ""
                                    }`}
                                    style={{
                                      minHeight: "2rem",
                                      padding:
                                        tag.financialAssets.length < 1
                                          ? "10px 30px"
                                          : "0px",
                                    }}
                                    onDragEnter={(e) => e.preventDefault()}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) =>
                                      handleDrop(e, "financialAssets", tx)
                                    }
                                    onDragLeave={(e) => e.preventDefault()}
                                  >
                                    {tag.financialAssets.length < 1 && (
                                      <label
                                        htmlFor="file-upload"
                                        className={`${standaloneCss.dragDropLabelTagAssets} mb-0`}
                                      >
                                        Drag and drop your Register here or
                                      </label>
                                    )}
                                    {tag.financialAssets.length > 0 &&
                                      tag.financialAssets.map((asset, ax) => (
                                        <div
                                          key={ax}
                                          className={`cursor-pointer text-secondary  d-flex align-items-center justify-content-between  ${standaloneCss.taggedAssets}`}
                                        >
                                          <div className="d-flex align-items-center">
                                            <div>
                                              <DotIndicatorSVGComponent
                                                color={"#DFE2E7"}
                                                height={21}
                                                width={13}
                                              />{" "}
                                            </div>
                                            <p
                                              className={`m-0 ml-2 ${commoncss.label3}`}
                                            >
                                              {asset?.sub_grp}
                                            </p>
                                          </div>
                                          <div
                                            onClick={() =>
                                              RemoveItem(
                                                asset,
                                                "financialAssets",
                                                tx
                                              )
                                            }
                                          >
                                            <RemoveIcon fontSize="small" />
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                        <p
                          className="text-secondary font-size-12 custom-font-500 font-inter cursor-pointer"
                          onClick={() => AddNewItem()}
                        >
                          + Add more class of assets
                        </p>
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="radius-10px mt-3 border">
                        <p className="m-0 p-3 font-weight-bold font-size-14 font-sans  border-radius-t-lf-10">
                          Category of assets - As per Financials
                        </p>

                        <div
                          className={`p-2 tag-assets-options bg-white ${commoncss.dFlexClm}`}
                          style={{
                            gap: "10px",
                            height: "76vh",
                            overflow: "auto",
                          }}
                        >
                          {assetsData.finanCialAssets.length > 0 &&
                            assetsData.finanCialAssets.map((asset, index) => (
                              <div
                                key={index}
                                draggable
                                onDragStart={(e) => handleDragStart(e, asset)}
                                className={`cursor-pointer text-secondary  d-flex align-items-center  ${standaloneCss.taggedAssets}`}
                              >
                                <div>
                                  <DotIndicatorSVGComponent
                                    color={"#DFE2E7"}
                                    height={21}
                                    width={13}
                                  />
                                </div>
                                <p className={`m-0 ml-2 ${commoncss.label3}`}>
                                  {asset?.sub_grp}
                                </p>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <Navbar /> */}
      <div className="container-fluid" hidden>
        {loading ? (
          <Loading />
        ) : (
          <div>
            <div>
              <button
                onClick={() => history.push(`/link-register`)}
                className="rounded back-btn btn btn-border-none pl-0 mt-3 ml-3"
              >
                <div className="d-flex custom-font-600 custom-common-theme-text-color">
                  <ArrowBackIcon className="mr-1" /> Back
                </div>
              </button>
            </div>

            <div className="d-flex bg-transparent mb-2">
              <div className="col-sm-3">
                <div className="radius-10px mt-3 border">
                  <p className="m-0 p-3 font-weight-bold font-size-14 font-sans  border-radius-t-lf-10">
                    Category of assets - Lease register
                  </p>
                  <div className="p-2 tag-assets-options bg-white ">
                    {assetsData.leaseAssets.length > 0 &&
                      assetsData.leaseAssets.map((asset, index) => (
                        <div
                          key={index}
                          draggable
                          onDragStart={(e) => handleDragStart(e, asset)}
                          className="mt-2 py-2 px-3 cursor-pointer radius-8px text-secondary font-size-14 border custom-bg-white-150 d-flex align-items-center"
                        >
                          <div>
                            <DotIndicatorSVGComponent
                              color={"#DFE2E7"}
                              height={21}
                              width={13}
                            />
                          </div>
                          <p className="m-0 custom-font-500 ml-2">
                            {asset?.assetClass}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div
                  className="w-100 d-flex justify-content-center align-items-center mt-1"
                  style={{ height: "1.5rem" }}
                >
                  {dropLoading && <LoaderTwo />}
                </div>

                <div className="d-flex flex-column justify-content-between border radius-10px bg-white">
                  <div>
                    <p className="m-0 px-3 py-2 border-radius-t-lf-10 font-size-16 custom-font-600 font-inter custom-bg-gray-300">
                      Enter class of assets
                    </p>
                    {tagAssets.length > 0 &&
                      tagAssets.map((tag, tx) => (
                        <div key={tx} className="p-2 mt-1">
                          <div className="d-flex justify-content-center align-items-center w-100">
                            <div className="tag-assets-option-hr"></div>
                            <p
                              className="text-secondary font-size-12 custom-font-500 font-inter m-0 text-center"
                              style={{ width: "20%" }}
                            >
                              Class of Assets {tx + 1}
                            </p>
                            <div className="tag-assets-option-hr"></div>
                          </div>

                          <div
                            className="d-flex justify-content-between pt-2"
                            style={{ gap: "10px" }}
                          >
                            <div
                              className="w-50"
                              style={{ minHeight: "2rem" }}
                              onDragEnter={(e) => e.preventDefault()}
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={(e) => handleDrop(e, "leaseAssets", tx)}
                              onDragLeave={(e) => e.preventDefault()}
                            >
                              {tag.leaseAssets.length > 0 &&
                                tag.leaseAssets.map((asset, ax) => (
                                  <div
                                    key={ax}
                                    className="mt-2 py-2 px-3 cursor-pointer radius-8px text-secondary font-size-14 border custom-bg-white-150 d-flex align-items-center justify-content-between"
                                  >
                                    <div className="d-flex align-items-center">
                                      <div>
                                        <DotIndicatorSVGComponent
                                          color={"#DFE2E7"}
                                          height={21}
                                          width={13}
                                        />
                                      </div>
                                      <p className="m-0 custom-font-500 ml-2">
                                        {asset?.assetClass}
                                      </p>
                                    </div>
                                    <div
                                      onClick={() =>
                                        RemoveItem(asset, "leaseAssets", tx)
                                      }
                                    >
                                      <RemoveIcon />
                                    </div>
                                  </div>
                                ))}
                            </div>
                            <div
                              className="w-50"
                              style={{ minHeight: "2rem" }}
                              onDragEnter={(e) => e.preventDefault()}
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={(e) =>
                                handleDrop(e, "financialAssets", tx)
                              }
                              onDragLeave={(e) => e.preventDefault()}
                            >
                              {tag.financialAssets.length > 0 &&
                                tag.financialAssets.map((asset, ax) => (
                                  <div
                                    key={ax}
                                    className="mt-2 py-2 px-3 cursor-pointer radius-8px text-secondary font-size-14 border custom-bg-white-150 d-flex align-items-center justify-content-between"
                                  >
                                    <div className="d-flex align-items-center">
                                      <div>
                                        <DotIndicatorSVGComponent
                                          color={"#DFE2E7"}
                                          height={21}
                                          width={13}
                                        />{" "}
                                      </div>
                                      <p className="m-0 custom-font-500 ml-2">
                                        {asset?.sub_grp}
                                      </p>
                                    </div>
                                    <div
                                      onClick={() =>
                                        RemoveItem(asset, "financialAssets", tx)
                                      }
                                    >
                                      <RemoveIcon />
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <p
                    className="text-secondary font-size-12 custom-font-500 font-inter cursor-pointer"
                    onClick={() => AddNewItem()}
                  >
                    + Add more class of assets
                  </p>
                </div>
              </div>

              <div className="col-sm-3">
                <div className="radius-10px mt-3 border">
                  <p className="m-0 p-3 font-weight-bold font-size-14 font-sans  border-radius-t-lf-10">
                    Category of assets - As per Financials
                  </p>

                  <div className="p-2 tag-assets-options bg-white">
                    {assetsData.finanCialAssets.length > 0 &&
                      assetsData.finanCialAssets.map((asset, index) => (
                        <div
                          key={index}
                          draggable
                          onDragStart={(e) => handleDragStart(e, asset)}
                          className="mt-2 py-2 px-3 cursor-pointer radius-8px text-secondary font-size-14 border custom-bg-white-150 d-flex align-items-center"
                        >
                          <div>
                            <DotIndicatorSVGComponent
                              color={"#DFE2E7"}
                              height={21}
                              width={13}
                            />
                          </div>
                          <p className="m-0 custom-font-500 ml-2">
                            {asset?.sub_grp}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default LeaseTagAssets;
